import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './Duperswiper';
import {
  getDuperbrowseNavigation,
  getIsDuperbrowseActive,
  getPreloadingEnabled,
} from '../../../Duperbrowse/redux/selectors';
import { movePrev, moveNext } from '../../../Duperbrowse/redux/actionCreators';
import { getIsDuperbrowseAllowed } from '../../../DeviationPage/redux/selectors';
import { DeviationPageStoreSlice } from '../../../DeviationPage/redux/types';

type StateProps = Pick<Props, 'navigation' | 'isEnabled' | 'preloadEnabled'>;
type DispatchProps = Pick<Props, 'moveNext' | 'movePrev'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, DeviationPageStoreSlice> = (
  state,
  ownProps
) => ({
  // zoom vs duper is messy
  isEnabled: !ownProps.isInZoomModal && getIsDuperbrowseAllowed(state),
  navigation: getDuperbrowseNavigation(state as any),
  duperActive: getIsDuperbrowseActive(state as any),
  preloadEnabled: getPreloadingEnabled(state as any),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  moveNext,
  movePrev,
};

export default connect(mapStateToProps, mapDispatchToProps);
